/**
 * Checkout verify routing — keep in sync with:
 *   llm_server/deployment_package/checkout_session_resolver.py
 */

/** Paddle transaction/checkout ids → POST /api/v1/payments/verify-transaction */
export function isPaddleTransactionCheckoutId(checkoutId) {
  if (!checkoutId || typeof checkoutId !== 'string') return false;
  const id = checkoutId.trim();
  return id.startsWith('txn_') || id.startsWith('che_');
}

/** Mock / customer ids → POST /api/v1/payments/verify-checkout-session */
export function isCatalogCheckoutId(checkoutId) {
  if (!checkoutId || typeof checkoutId !== 'string') return false;
  const id = checkoutId.trim().toLowerCase();
  // ***** Code Start BH29072026_1105 - Reject mock catalog ids in production unless opted in (Sathis)
  const isDevOrMockAllowed =
    process.env.NODE_ENV === 'development' || process.env.REACT_APP_ALLOW_MOCK_PAYMENTS === 'true';
  if (!isDevOrMockAllowed && id.includes('mock')) {
    return false;
  }
  // ***** Code End BH29072026_1105
  return (
    id.startsWith('cs_mock_') ||
    id.startsWith('mock_') ||
    id.startsWith('2co_') ||
    id.startsWith('ctc_') ||
    id.startsWith('ctm_') ||
    id.includes('mock')
  );
}

/**
 * @returns {'verify-transaction'|'verify-checkout-session'}
 */
export function resolveCheckoutVerifyEndpoint(checkoutId) {
  return isPaddleTransactionCheckoutId(checkoutId)
    ? 'verify-transaction'
    : 'verify-checkout-session';
}
